import { Station } from '@mi-front/core';
import { useMemo } from 'react';
import { isOwnedStation } from '../helpers';
import { useStations } from './useStations';

/**
 * Returns only stations owned by the authenticated client.
 * Optionally accepts an extra filter for specific screens.
 */
export function useOwnedStations(filter?: (station: Station) => boolean): readonly Station[] {
  const stations = useStations(isOwnedStation);

  return useMemo(() => (filter ? stations.filter(filter) : stations), [stations, filter]);
}
